import { Header as SignupOneCredentialRequireAuthKeyHeader } from './components/SignupOneCredentialSkeleton/Header';
import { Content as SignupOneCredentialRequireAuthKeyContent } from './components/SignupOneCredentialSkeleton/Content';
import { Footer as SignupOneCredentialRequireAuthKeyFooter } from './components/SignupOneCredentialSkeleton/Footer';

// Components
import DummyComponent from './components/DummyComponent';
export { default as GenericPopup } from './components/GenericPopup';
export { default as ResponsiveImage } from './components/ResponsiveImage';
export { default as NotFound } from './components/NotFound';
export { default as AccountPasswordForm } from './components/AccountPasswordForm';
export { default as AccountPasswordRules } from './components/AccountPasswordRules';
export { default as AuthPasswordForm } from './components/AuthPasswordForm';
export { default as AuthPasswordRules } from './components/AuthPasswordRules';
export { default as LoginByPasswordForm } from './components/LoginByPasswordForm';
export { default as SignupByOTPForm } from './components/SignupByOTPForm';
export { default as InputPassword } from './components/InputPassword';
export { default as LoginInputPassword } from './components/LoginInputPassword';
export { default as InputAuthKey } from './components/InputAuthKey';
export { default as LoginByPasswordInputAuthKeyV2 } from './components/LoginByPasswordInputAuthKeyV2';
export { default as SignupInputAuthKey } from './components/SignupInputAuthKey';
export { default as SignupInputAuthKeyV2 } from './components/SignupInputAuthKeyV2';
export { default as SignupTermsOfService } from './components/SignupTermsOfService';
export { default as InputResetPasswordKey } from './components/InputResetPasswordKey';
export { default as InputCheckbox } from './components/InputCheckbox';
export { default as AccessibleSpan } from './components/AccessibleSpan';
export { default as OneCredentialMigrateSuccessImage } from './components/OneCredentialMigrateSuccessImage';
export { default as OneCredentialMigrateOverviewBackgroundImage } from './components/OneCredentialMigrateOverviewBackgroundImage';
export { CommonNavbarHelpButton } from './components/CommonNavbarHelpButton';
export { default as ResponsiveBackgroundContainer } from './components/ResponsiveBackgroundContainer';
export { InputLoginByOtpAuthKey } from './components/InputLoginByOtpAuthKey';
export { Toast } from './components/Toast';
export { default as Tip } from './components/Tip';
export { default as AccountPageHelpFooter } from './components/AccountPageHelpFooter';
export { default as LoginLink } from './components/LoginLink';
export { default as SignupAlreadyRegisteredLogo } from './components/SignupAlreadyRegisteredLogo';
export { default as DesktopNavbar } from './components/DesktopNavbar';
export { default as SignupByOtpTip } from './components/SignupByOtpTip';
export { default as LinkingNoticeImage } from './components/LinkingNoticeImage';
export { default as LoginTermsOfService } from './components/LoginTermsOfService';
export { default as SignupContactUsMessage } from './components/SignupContactUsMessage';
export { default as DialogWithButtonConfigs } from './components/DialogWithButtonConfigs';
export { default as EnforceSetNewPasswordDialog } from './components/EnforceSetNewPasswordDialog';
export { default as LanguageSelectorDropdown } from './components/LanguageSelectorDropdown';
export { default as SignupLink } from './components/SignupLink';
export { default as ResetPasswordLinkContent } from './components/ResetPasswordLinkContent';
export { default as LoginByPasswordFooter } from './components/LoginByPasswordFooter';
export { default as ThirdPartyAuthenticationComponents } from './components/ThirdPartyAuthenticationComponents';
export { default as OneCredentialDelinkLogo } from './components/OneCredentialDelinkLogo';
export { default as OneCredentialDelinkSuccessImage } from './components/OneCredentialDelinkSuccessImage';
export { default as OneCredentialDelinkInputAuthKey } from './components/OneCredentialDelinkInputAuthKey';

export const SignupRequireAuthKey = {
  Header: DummyComponent,
  Content: DummyComponent,
  Footer: DummyComponent,
};

export const SignupOneCredentialRequireAuthKey = {
  Header: SignupOneCredentialRequireAuthKeyHeader,
  Content: SignupOneCredentialRequireAuthKeyContent,
  Footer: SignupOneCredentialRequireAuthKeyFooter,
};

export const LoginByPasswordOneCredentialRequirePassword = {
  Header: DummyComponent,
  Content: DummyComponent,
  Foooter: DummyComponent,
};

// Icons
export { default as IconNotFound } from './components/Icons/IconNotFound';

export const LoginByPasswordRequirePassword = {
  Header: DummyComponent,
  Content: DummyComponent,
  Footer: DummyComponent,
};

export const LoginByOtpOneCredentialRequireAuthKey = {
  Header: DummyComponent,
  Content: DummyComponent,
  Footer: DummyComponent,
};

export const LoginByOtpOneCredentialOptionalRequireAuthKey = {
  Header: DummyComponent,
  Content: DummyComponent,
  Footer: DummyComponent,
};

export const SignupByOtpOneCredentialOptionalRequireAuthKey = {
  Header: DummyComponent,
  Content: DummyComponent,
  Footer: DummyComponent,
};

export const LoginByPasswordOneCredentialOptionalRequirePassword = {
  Header: DummyComponent,
  Content: DummyComponent,
  Footer: DummyComponent,
};
